import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getTestById, updateTest } from "../../services/api"; // Asegúrate de tener estas funciones en tu API
import Breadcrumbs from "../../components/BreadCrumbs";

const TestUpdate = () => {
  const { projectId, testId } = useParams();
  const navigate = useNavigate();
  const [testData, setTestData] = useState({
    nombre: "",
    descripcion: "",
    assignedTo: "",
    estado: "",
  });

  useEffect(() => {
    const fetchTest = async () => {
      try {
        const response = await getTestById(projectId, testId);
        console.log(response);
        setTestData(response);
      } catch (error) {
        console.error("Error al obtener el caso de prueba", error);
      }
    };

    fetchTest();
  }, [projectId, testId]);

  const handleChange = (e) => {
    setTestData({
      ...testData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateTest(testId, testData);
      navigate(`/dashboard/projects/${projectId}/tests`);
    } catch (error) {
      console.error("Error al actualizar el caso de prueba", error);
    }
  };

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Projects", url: "/dashboard/projects" },
    { name: "Test", url: "/dashboard/projects/" + projectId + "/tests" },
    {
      name: "update test",
      url: "/dashboard/projects/" + projectId + "/test/update/" + testId,
    },
  ];

  return (
    <>
      <h2>Actualizar Caso de Prueba</h2>
      <Breadcrumbs paths={breadcrumbPaths} />
      <form onSubmit={handleSubmit}>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">
            Nombre del Caso de Prueba
          </label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="nombre"
              value={testData.nombre}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Descripción</label>
          <div class="col-sm-10">
            <textarea
              className="form-control"
              name="descripcion"
              value={testData.descripcion}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Asignado a</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="assignedTo"
              value={testData.assignedTo}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Estado</label>
          <div class="col-sm-10">
            <select
              className="form-select"
              name="estado"
              value={testData.estado}
              onChange={handleChange}
              required
            >
              <option value="">Seleccionar...</option>
              <option value="Nuevo">Nuevo</option>
              <option value="En progreso">En progreso</option>
              <option value="Completado">Completado</option>
            </select>
          </div>
        </div>
        <div style={{ textAlign: "end" }}>
          <button type="submit" className="btn btn-primary">
            Actualizar
          </button>
        </div>
      </form>
    </>
  );
};

export default TestUpdate;
